<template>
  <button
    v-if="$sitewideConfig.config.nonTransactionalEnabled"
    class="flex text-inherit items-center cursor-pointer"
    @click="togglePrices"
  >
    <span :class="classes">{{ data.label }}</span>
    <span
      class="flex-none ml-2 h-4 w-6 lg:w-8 flex items-center rounded-full border-2 border-transparent"
      :class="isPriceEnabled ? 'bg-success-dark' : 'bg-gray-dark'"
    >
      <span
        class="h-3 w-3 bg-white rounded-full transform shadow"
        :class="[!isPriceEnabled ? 'translate-x-0' : 'translate-x-2 lg:translate-x-4']"
      ></span>
    </span>
  </button>
</template>

<script setup lang="ts">
const { $sitewideConfig } = useNuxtApp()
const { isPriceEnabled, togglePrices } = usePriceToggle()

interface PriceToggleWidget extends Widget {
  label: string
  color: FontColor
  size: FontSize
}

const { data } = defineProps<{
  data: PriceToggleWidget
}>()

const classes = computed(() => {
  const color = generateFontColorClass(data.color)
  const size = generateFontSizeClass(data.size)
  return [color, size]
})
</script>
